import { Routes, RouterModule } from '@angular/router';

export const MainLayout_ROUTES: Routes = [
    {
        path: '',
        loadChildren: () => import('../../pages/page-routing.module').then(m => m.PageRoutingModule)
    }
];